module.exports = __webpack_public_path__ + "media/images/icons/social/instagram-36945d249926aa0d65ef3c4157403e2812ed0cb04e6c9dabd37343d19212fb80.svg";